// extracted by mini-css-extract-plugin
export default {"root":"MarketingConsent-module_root_a49622","checkbox":"MarketingConsent-module_checkbox_e9a994","helperText":"MarketingConsent-module_helperText_e792b1"};